export enum AuthenticationProvider {
  NotRequired,
  Authenticator,
}
